export enum Department {
  ADMINISTRATION = "ADMINISTRATION",
  OPERATOR = "OPERATOR"
}
